import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"

export const useLocation = () => {
  const locations = useStaticQuery(graphql`
    query LocationQuery {
      allDatoCmsLocation(
        sort: { fields: position, order: ASC }
      ) {
        nodes {
          id
          name
          body
          position
        }
      }
    }
  `)

  const i18nLocations = locations.allDatoCmsLocation.nodes;

  return i18nLocations
}
